import get from 'lodash/get';

const getEventName = () => {
  return {
    cardDetails: {
      application_event: 'started',
      event_action: '',
      event_category: '',
      event_content: '',
      event_subcategory: '',
    },
    processing: {
      application_event: 'submitted',
      event_action: '',
      event_category: '',
      event_content: '',
      event_subcategory: '',
    },
    cardSuccess: {
      application_event: 'completed',
      event_action: '',
      event_category: '',
      event_content: '',
      event_subcategory: '',
    },
    errorPage: {
      application_event: '',
      event_action: 'application',
      event_category: 'error',
      event_content: 'technical error',
      event_subcategory: '',
    },
    timeout: {
      application_event: '',
      event_action: 'application',
      event_category: 'error',
      event_content: 'timeout',
      event_subcategory: 'timeout',
    },
  };
};

const getEventData = (currentPage) => {
  return {
    ...get(getEventName(), currentPage),
  };
};

export default getEventData;
